import React, { useState, useEffect } from "react";
import { ReactComponent as WebhookIcon } from "assets/img/icons/webhook.svg";
import { Modal } from "react-responsive-modal";
import Button from "components/CustomButton";
import Input from "components/CustomInput/CustomInput";
import * as Yup from "yup";
import { useFormik } from "formik";
import TeamService from "services/TeamService";
import { useTeamContext } from "store/contexts/teamContext";
import Loader from "components/Loader";
import { useToasts } from "react-toast-notifications";
import DropDown from "components/CustomDropDown";

const styles = {
  root: {
    cursor: "pointer",
    alignItems: "center",
    display: "flex",
  },
  avatar: {
    width: "20px",
    height: "23px",
    marginRight: "0.25 !important",
  },
  modalRoot: {
    padding: "25px 20px",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modalHeaderLeft: {
    fontSize: "20px",
    fontWeight: 500,
  },
  modalDescription: {
    fontSize: "15px",
    letterSpacing: "0.2px",
  },
  anotherModalHeader: {
    fontSize: "20px",
    fontWeight: 500,
    display: "flex",
    justifyContent: "center",
  },
  anothetModalContent: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    paddingTop: "15px",
  },
  cancelStyle: {
    background: "none",
    color: "black",
  },
  modalFooter: {
    paddingTop: "20px",
    display: "flex",
    justifyContent: "flex-end",
  },
  anotherModalFooter: {
    display: "flex",
    gap: "15px",
  },
  loaderStyle: {
    display: "flex",
    justifyContent: "center",
  },
  errorMessage: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "20px",
    color: "red",
  },
  submitLoader: {
    display: "flex",
    justifyContent: "center",
    height: "100%",
    alignItems: "center",
  },
  webhookUrl: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#3e80cc",
  },
  modalContent: {
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "5px",
    marginTop: "5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  actionButton: {
    display: "flex",
    gap: "5px",
  },
  deleteModalFooter: {
    paddingTop: "15px",
    display: "flex",
    gap: "15px",
  },
  webhookOption: {
    position: "relative",
    height: "50px",
    border: "1px solid #43434317",
    borderRadius: "6px",
    padding: "10px",
    display: "flex",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: 400,
    justifyContent: "space-between",
    cursor: "pointer",
  },
  optionDropDown: {
    position: "absolute",
    background: "white",
    left: 0,
    width: "100%",
    top: "50px",
    padding: "5px",
    borderRadius: "6px",
    border: "1px solid #a1a2a9",
  },
  optionName: {
    padding: "5px 10px",
    borderBottom: "1px solid #dee2e6",
  },
  modalContentOption: {
    border: "1px solid rgba(67, 67, 67, 0.09)",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "15px",
    marginTop: "5px",
  },
  webhookContent: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  webhookError: {
    position: "absolute",
    top: "60px",
    left: 0,
    color: "red",
  },
  noWebhookContent: {
    pointerEvents: "none",
    cursor: "none",
  },
  webhookHeading: {
    fontSize: "15px",
    fontWeight: 500,
  },
};

export default () => {
  const classes = styles;
  const { team } = useTeamContext();
  const [dialogState, setDialogState] = useState(false);
  const [anotherDialog, setAnotherDialogState] = useState(false);
  const [ringCentralWebhook, setRingCentralWebhook] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [openDeleteModal, setDeleteModal] = useState(false);
  const [microsoftTeamsWebhook, setMicrosoftTeamsWebhook] = useState();
  const [typeId, setTypeId] = useState();
  const [microsoftId, setMicrosoftId] = useState();
  const [heading, setHeading] = useState("Add Webhook");
  const [webhookTypes] = useState([
    {
      typeId: 1,
      name: "Microsoft Teams",
    },
    {
      typeId: 2,
      name: "Ring Central",
    },
  ]);
  const [deleting, setDeleting] = useState(false);
  const { addToast } = useToasts();
  Yup.addMethod(Yup.string, "validateurl", function (message) {
    return this.test("unique", message, function (response) {
      if (!response) return false;
      var totalValue = response.split("/");

      if (totalValue.length > 3) {
        totalValue.splice(3, totalValue.length - 3);
      }

      var finalValue = totalValue.join("");
      var result = finalValue.match(
        //eslint-disable-next-line
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );

      if (result) {
        return true;
      }
    });
  });

  useEffect(() => {
    if (!dialogState) {
      return;
    }

    // if (ringCentralWebhook) {
    //   return;
    // }

    (async () => {
      setLoading(true);
      try {
        var response = await TeamService.getWebhooks(team?.id);

        if (response) {
          setRingCentralWebhook({
            url: response.data.data.incoming_webhook_url,
            name: "Ring Central",
            type_id: 2,
          });
        }
      } catch (error) {}

      try {
        var response2 = await TeamService.getWebhookMicrosoftTeamsUrl(team?.id);

        if (response2.data.data.length !== 0) {
          setMicrosoftTeamsWebhook({
            ...response2.data.data[0],
            name: "Ms Teams",
          });
          formik.setFieldValue("webhookType", {
            typeId: 2,
            name: "Ring Central",
          });
        }
      } catch (e) {}

      if (!response && !response2) {
        setErrorMessage(
          "There is Ring Central And Ms Teams Configuration for this team."
        );
      }
      setLoading(false);
    })();

    return () => {
      formik.resetForm();
    };

    //eslint-disable-next-line
  }, [team, dialogState]);

  const formik = useFormik({
    initialValues: {
      url: "",
      createNew: false,
      webhookType: { ...webhookTypes[0] },
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: Yup.object().shape({
      webhookType: Yup.object().shape({
        typeId: Yup.number().required(),
        name: Yup.string().required(),
      }),
      url: Yup.string()
        .validateurl("Please Enter A Valid Url")
        .required("Url is required field."),
    }),
    onSubmit: async (values) => {
      try {
        setDisableButton(true);
        if (values.createNew && values.webhookType.typeId === 2) {
          await TeamService.postWebhookUrl(team.id, values.url);
          setRingCentralWebhook({
            url: values.url,
            type_id: values.webhookType.typeId,
            name: "Ring Central",
          });
          formik.setFieldValue("webhookType", {
            typeId: 1,
            name: "MS Teams",
          });
          addToast("Url added successfully ", { appearance: "success" });
        }

        if (values.createNew && values.webhookType.typeId === 1) {
          var response = await TeamService.postWebhookMicrosoftTeamUrl(
            team.id,
            values.url
          );
          setMicrosoftTeamsWebhook({
            id: response.data.data.id,
            url: values.url,
            type_id: response.data.data.type_id,
            name: "MS Teams",
          });
          formik.setFieldValue("webhookType", {
            typeId: 2,
            name: "Ring Central",
          });
          addToast("Url added successfully ", { appearance: "success" });
        }

        if (!values.createNew && typeId === 2) {
          await TeamService.updateWebhookUrl(team.id, values.url);
          addToast("Url updated successfully ", { appearance: "success" });
        }

        if (!values.createNew && typeId === 1) {
          await TeamService.updateWebhookMicrosoftTeamUrl(
            team.id,
            values.url,
            typeId,
            microsoftId
          );
          addToast("Url updated successfully ", { appearance: "success" });
        }

        setAnotherDialogState(false);
      } catch (error) {}
      setDisableButton(false);
    },
  });

  const handleWebhookType = (type) => {
    formik.setFieldValue("webhookType", {
      typeId: type.typeId,
      name: type.name,
    });
  };

  const handleCloseAnotherDialog = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    setAnotherDialogState(false);
  };

  const handleAnotherModal = (text, createUrl, typeId, id) => {
    setErrorMessage();
    setHeading(text);
    setAnotherDialogState(true);
    setTypeId(typeId);
    setMicrosoftId(id);

    if (createUrl) {
      formik.setFieldValue("createNew", true);
      formik.setFieldValue("url", "");
      return;
    }
    formik.setFieldValue("createNew", false);
  };

  const deleteWebHook = async () => {
    setDeleting(true);
    setDisableButton(true);
    try {
      if (typeId === 2) {
        await TeamService.deleteWebhookUrl(team.id);
        formik.setFieldValue("webhookType", {
          typeId: typeId,
          name: "Ring Central",
        });
      }

      if (typeId === 1) {
        await TeamService.deleteMicrosoftTeamsWebhook(team.id, microsoftId);
        formik.setFieldValue("webhookType", {
          typeId: typeId,
          name: "Microsoft Teams",
        });
      }

      addToast("Url deleted successfully. ", { appearance: "success" });
    } catch (e) {
      console.log(e);
    }
    setDeleting(false);
    setDisableButton(false);
    formik.setFieldValue("url", "");
    setDeleteModal(false);
    if (typeId === 2) {
      setRingCentralWebhook();
    }

    if (typeId === 1) {
      setMicrosoftTeamsWebhook();
    }

    if (!ringCentralWebhook && !microsoftTeamsWebhook) {
      setErrorMessage(
        "There is no Ring Central and Ms Team configuration exists for this team"
      );
    }
  };

  const handleDelete = (typeId, msId = null, openDeleteModal) => {
    setTypeId(typeId);
    setMicrosoftId(msId);
    setDeleteModal(openDeleteModal);
  };

  return (
    <>
      <div style={classes.root} onClick={() => setDialogState(true)}>
        <WebhookIcon className="mx-2" style={classes.avatar} />
        <span>Webhooks</span>
      </div>
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal: "teamInformationModalContainer",
        }}
        open={dialogState}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        showCloseIcon={false}
        onClose={() => setDialogState(false)}
      >
        <div style={classes.modalRoot}>
          <div style={classes.modalHeader}>
            <span style={classes.modalHeaderLeft}>Webhooks</span>
            {(!ringCentralWebhook || !microsoftTeamsWebhook) && !loading && (
              <span>
                <Button
                  disabled={disableButton && true}
                  onClick={() =>
                    handleAnotherModal("Add Webhook", true, null, null)
                  }
                  buttonClass="light-gray-btn d-inline-block"
                >
                  Add webhook
                </Button>
              </span>
            )}
          </div>
          <hr />
          <div>
            <span style={classes.modalDescription}>
              Webhooks allow external services to be notified when certain
              events happen. When the specified events happen, we'll send a POST
              request to each of the URLS you provide.
            </span>
            {loading && (
              <div style={classes.loaderStyle}>
                <Loader />
              </div>
            )}
            {!loading && errorMessage && !ringCentralWebhook && (
              <div>
                <span style={classes.errorMessage}>{errorMessage}</span>
              </div>
            )}
            {!loading && ringCentralWebhook && !errorMessage && (
              <div style={{ marginTop: "10px" }}>
                <span style={classes.webhookHeading}>
                  {ringCentralWebhook.name} Webhook
                </span>
                <div style={classes.modalContent}>
                  <div style={classes.webhookUrl}>{ringCentralWebhook.url}</div>
                  <span style={classes.actionButton}>
                    <Button
                      buttonClass=" small-reject-btn"
                      disabled={disableButton && true}
                      onClick={() =>
                        handleDelete(ringCentralWebhook.type_id, null, true)
                      }
                    >
                      {deleting ? <Loader width={20} height={20} /> : "Delete"}
                    </Button>
                    <Button
                      disabled={disableButton && true}
                      buttonStyle={{ width: "67px" }}
                      buttonClass="small-accept-btn"
                      onClick={() =>
                        handleAnotherModal(
                          "Update RingCentral Webhook",
                          false,
                          ringCentralWebhook.type_id,
                          null
                        )
                      }
                    >
                      Edit
                    </Button>
                  </span>
                </div>
              </div>
            )}
            {!loading && microsoftTeamsWebhook && !errorMessage && (
              <div style={{ marginTop: "10px" }}>
                <span style={classes.webhookHeading}>
                  {microsoftTeamsWebhook.name} Webhook
                </span>
                <div style={classes.modalContent}>
                  <div style={classes.webhookUrl}>
                    {microsoftTeamsWebhook.url}
                  </div>
                  <span style={classes.actionButton}>
                    <Button
                      buttonClass=" small-reject-btn"
                      disabled={disableButton && true}
                      onClick={() =>
                        handleDelete(
                          parseInt(microsoftTeamsWebhook.type_id),
                          parseInt(microsoftTeamsWebhook.id),
                          true
                        )
                      }
                    >
                      {deleting ? <Loader width={20} height={20} /> : "Delete"}
                    </Button>
                    <Button
                      disabled={disableButton && true}
                      buttonStyle={{ width: "67px" }}
                      buttonClass="small-accept-btn"
                      onClick={() =>
                        handleAnotherModal(
                          "Update MS Teams Webhook",
                          false,
                          parseInt(microsoftTeamsWebhook.type_id),
                          parseInt(microsoftTeamsWebhook.id)
                        )
                      }
                    >
                      Edit
                    </Button>
                  </span>
                </div>
              </div>
            )}
          </div>
          <div style={classes.modalFooter}>
            <Button
              disabled={disableButton && true}
              buttonClass="grad_btn join-btn"
              buttonStyle={classes.cancelStyle}
              onClick={() => setDialogState(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "teamInformationModalContainer",
        }}
        open={anotherDialog}
        showCloseIcon={false}
        onClose={() => setAnotherDialogState(false)}
      >
        <div style={classes.modalRoot}>
          <div style={classes.anotherModalHeader}>{heading}</div>
          <hr />
          <div>
            <span style={classes.modalDescription}>
              We’ll send a POST request to the URL below with details of every
              post creation.
            </span>
          </div>
          <form noValidate onSubmit={formik.handleSubmit}>
            <div style={classes.anothetModalContent}>
              <div style={classes.modalContentOption}>
                <div>
                  <Input
                    id={"url"}
                    inputClass="full_w webhookInput"
                    formGroup={false}
                    inputProps={{
                      type: "url",
                      placeholder: "Payload Url",
                      ...formik.getFieldProps("url"),
                      error:
                        !!formik.errors.url && !!formik.touched.url
                          ? formik.errors.url
                          : null,
                    }}
                  />
                </div>
                {formik.values.createNew && (
                  <DropDown
                    dropDownData={webhookTypes}
                    onClick={(webhook) => {
                      handleWebhookType(webhook);
                    }}
                    dropDownStyle={classes.webhookOption}
                    name={formik.values.webhookType.name}
                    contentStyle={{ width: "100%" }}
                    headerStyle={
                      !ringCentralWebhook && !microsoftTeamsWebhook
                        ? classes.webhookContent
                        : classes.noWebhookContent
                    }
                    optionStyle={classes.optionName}
                    displayArrow={!ringCentralWebhook && !microsoftTeamsWebhook}
                  />
                )}
              </div>
              <div style={classes.anotherModalFooter}>
                <Button
                  disabled={disableButton && true}
                  buttonClass="grad_btn join-btn"
                >
                  {!disableButton ? (
                    "Submit"
                  ) : (
                    <div style={classes.submitLoader}>
                      <Loader width={40} height={40} />
                    </div>
                  )}
                </Button>
                <Button
                  disabled={disableButton && true}
                  buttonClass="grad_btn join-btn"
                  buttonStyle={classes.cancelStyle}
                  onClick={handleCloseAnotherDialog}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "teamInformationModalContainer",
        }}
        open={openDeleteModal}
        showCloseIcon={false}
        onClose={() => handleDelete(null, null, false)}
      >
        <div style={classes.modalRoot}>
          <div style={classes.anotherModalHeader}>Delete Url</div>
          <hr />
          <div style={classes.modalDescription}>
            Please confirm do you want to delete your url? Please Note that if
            you delete the url, you will not going to notified further.
          </div>
          <div style={classes.deleteModalFooter}>
            <Button
              disabled={disableButton && true}
              onClick={deleteWebHook}
              buttonClass="grad_btn join-btn"
            >
              {!disableButton ? (
                "Confirm"
              ) : (
                <div style={classes.submitLoader}>
                  <Loader width={40} height={40} />
                </div>
              )}
            </Button>
            <Button
              disabled={disableButton && true}
              buttonClass="grad_btn join-btn"
              buttonStyle={classes.cancelStyle}
              onClick={() => handleDelete(null, null, false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
